function NotebooksIcon() {
  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        clip-rule="evenodd"
        d="M2 2.82446H14V5.82446H2L2 2.82446ZM1 2.82446C1 2.27218 1.44772 1.82446 2 1.82446H14C14.5523 1.82446 15 2.27218 15 2.82446V5.82446C15 6.37675 14.5523 6.82446 14 6.82446H2C1.44772 6.82446 1 6.37675 1 5.82446V2.82446ZM2 8.82446H14V14.8245H2L2 8.82446ZM1 8.82446C1 8.27218 1.44772 7.82446 2 7.82446H14C14.5523 7.82446 15 8.27218 15 8.82446V14.8245C15 15.3767 14.5523 15.8245 14 15.8245H2C1.44772 15.8245 1 15.3767 1 14.8245V8.82446Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

function DataAppsIcon() {
  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M8 2.70703H2V14.707H8V2.70703ZM9 2.70703V8.70703H14V2.70703H9ZM9 9.70703V14.707H14V9.70703H9ZM2 1.70703C1.44772 1.70703 1 2.15475 1 2.70703V14.707C1 15.2593 1.44772 15.707 2 15.707H14C14.5523 15.707 15 15.2593 15 14.707V2.70703C15 2.15475 14.5523 1.70703 14 1.70703H2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

function SelfServeIcon() {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M0.5 8.00244C0.5 3.86031 3.85786 0.502441 8 0.502441C12.1421 0.502441 15.5 3.86031 15.5 8.00244C15.5 12.1446 12.1421 15.5024 8 15.5024C3.85786 15.5024 0.5 12.1446 0.5 8.00244ZM8 1.50244C4.41015 1.50244 1.5 4.41259 1.5 8.00244C1.5 11.5923 4.41015 14.5024 8 14.5024C11.5899 14.5024 14.5 11.5923 14.5 8.00244C14.5 4.41259 11.5899 1.50244 8 1.50244ZM11.3536 4.64889C11.5057 4.80107 11.5435 5.03355 11.4472 5.22605L9.44721 9.22605C9.39883 9.32281 9.32037 9.40127 9.22361 9.44965L5.22361 11.4497C5.03111 11.5459 4.79863 11.5082 4.64645 11.356C4.49427 11.2038 4.45654 10.9713 4.55279 10.7788L6.55279 6.77883C6.60117 6.68207 6.67963 6.60361 6.77639 6.55523L10.7764 4.55523C10.9689 4.45898 11.2014 4.49671 11.3536 4.64889ZM7.37268 7.37512L6.11803 9.88441L8.62732 8.62976L9.88197 6.12048L7.37268 7.37512Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export const config = {
  workflows: {
    notebooks: {
      color: '#5CB198',
      icon: <NotebooksIcon />,
      anchor: 'notebooks',
      noise: 'url(/images/home-2025/textures/noise-jade-128x128.png)'
    },
    data_apps: {
      color: '#CDA849',
      icon: <DataAppsIcon />,
      anchor: 'data-apps',
      noise: 'url(/images/home-2025/textures/noise-citrine-128x128.png)'
    },
    self_serve: {
      color: '#A477B2',
      icon: <SelfServeIcon />,
      anchor: 'self-serve',
      noise: 'url(/images/home-2025/textures/noise-amythyst-128x128.png)'
    }
  }
} as const;
